import React from 'react';
import { connect } from 'react-redux';
import { bool, number, func, string, instanceOf } from 'prop-types';
import { isEmpty } from '@widergy/web-utils/lib/array';

import { message } from 'utils/stringUtils';
import { referenceType, officeSlotType } from 'types/turnsTypes';

import GridWrapper from '../../../components/GridWrapper';
import CardError from '../CardError';

import CardSlot from './components/CardSlot';
import styles from './styles.module.scss';
import { SIZE_LOADING } from './constants';

const OfficeSlot = ({
  refOfficeSlot,
  currentOfficeSlot,
  currentDay,
  handleSetOfficeSlot,
  reload,
  officeSlot,
  officeSlotLoading,
  officeSlotError
}) => {
  const handleRenderSlot = item => (
    <CardSlot
      id={item.id}
      beginsAt={item.begins_at}
      endsAt={item.ends_at}
      selected={item.id === currentOfficeSlot}
      onClick={handleSetOfficeSlot}
    />
  );

  return (
    <GridWrapper
      reference={refOfficeSlot}
      title={message('Turns:selectTime')}
      loading={officeSlotLoading}
      classNameLoading={styles.containerLoading}
      hasElements={!isEmpty(officeSlot)}
      className={!currentDay && styles.hidden}
      sizeLoading={SIZE_LOADING}
    >
      {isEmpty(officeSlot) ? (
        <CardError
          error={officeSlotError}
          buttonFunction={officeSlotError && reload}
          title={!officeSlotError && message('Turns:withoutSlots')}
        />
      ) : (
        officeSlot.map(handleRenderSlot)
      )}
    </GridWrapper>
  );
};

OfficeSlot.propTypes = {
  refOfficeSlot: referenceType,
  currentOfficeSlot: number,
  currentDay: instanceOf(Date),
  handleSetOfficeSlot: func.isRequired,
  reload: func,
  officeSlot: officeSlotType,
  officeSlotLoading: bool,
  officeSlotError: string
};

const mapStateToProps = store => ({
  officeSlot: store.utility.officeSlot,
  officeSlotError: store.utility.officeSlotError,
  officeSlotLoading: store.utility.officeSlotLoading
});

export default connect(mapStateToProps)(OfficeSlot);
